import React from 'react';
import './Copies.scss';
import drRice from '../../assets/dr.rice.jpg';

function Copy2() {
  return (
    <section className="copies">
      <h4 className="copies__title title">WHAT IS ECZEMA?</h4>

      <p className="copies__copy">
        Eczema, also known as atopic dermatitis, is one of the most common and chronic skin
        conditions.<sup className="copies__copy--sup">3</sup> In fact, it’s one of the most common
        health problems worldwide.
        <sup className="copies__copy--sup">3</sup> AD affects up to 36% of the pediatric population
        and up to almost 23% of the adult population worldwide.
        <sup className="copies__copy--sup">4,5,6,7</sup>
      </p>
      <div className="inlinePhoto inlinePhoto--desktop">
        <img className="inlinePhoto__image" src={drRice} alt="Portrait of Dr. Zakiya Rice" />
        <p className="inlinePhoto__name inlinePhoto--description">Dr. Zakiya Rice</p>
        <p className="inlinePhoto__title inlinePhoto--description">Dermatologist</p>
      </div>
      <p className="copies__copy">
        There is one important element that Dr. Zakiya Rice, a dermatologist, adjunct clinical
        professor at Emory Dermatology, and associate at Dermatology Associates of Georgia, makes
        very clear: “As a parent, you did nothing wrong. [Your] child did nothing wrong. If you're
        an adult getting it as new onset, you did nothing wrong.”
        <sup className="copies__copy--sup">8</sup>
      </p>
      <div className="inlinePhoto inlinePhoto--mobile">
        <img className="inlinePhoto__image" src={drRice} alt="Portrait of Dr. Zakiya Rice" />
        <p className="inlinePhoto__name inlinePhoto--description">Dr. Zakiya Rice</p>
        <p className="inlinePhoto__title inlinePhoto--description">Dermatologist</p>
      </div>
      <p className="copies__copy">
        A family history of eczema, asthma, and/or hay fever is a risk factor, although the skin
        disease is thought to have more than one cause.
        <sup className="copies__copy--sup">9</sup> Eczema can occur at any age, although eczema in
        children generally begins before age five.
        <sup className="copies__copy--sup">10</sup> While there are treatments available, there is
        no known cure for eczema.
        <sup className="copies__copy--sup">5</sup> But it’s not a life sentence, and Rice likes to
        reassure her patients that there is a good chance they can even grow out of it.
      </p>
      <p className="copies__copy">
        The first thing someone with eczema may notice is the itching. “A hallmark of eczema is
        itching,” Dr. Rice says. "Actually, there’s a saying: If it ain't itching, it ain't eczema!”
      </p>
      <p className="copies__copy">
        Although the main symptoms of eczema are somewhat constant (patches of itchy, scaly rash,
        and dry skin), the condition presents differently on different skin tones.
        <sup className="copies__copy--sup">2</sup> Rice uses the dermatology standard Fitzpatrick
        scale, which categorizes the range of skin color from one to six. The scale is a
        dermatological tool; a way to classify skin color based on skin pigmentation. Dr. Rice
        explains that:
      </p>
      <p className="copies__copy">
        “Someone who is a 1 is someone who has blue eyes, red hair, and never tans, and someone who
        is maybe a 6 is someone who basically no matter how long in the sun would never burn. So,
        probably someone who is more native to Africa. That is the best classification we have for
        skin type, and then typically we think of skin of color as being 3 to 6.” The issue with
        diagnosis is that photo examples of 3 to 6 are not readily available to medical
        professionals (or to the average parent on the internet).
        <sup className="copies__copy--sup">8</sup>
      </p>
    </section>
  );
}

export default Copy2;
